import { Pipe, PipeTransform } from '@angular/core';
import { DataObject, StoreBootstrap } from '@app/_shared/interfaces';

@Pipe({
  name: 'isShopify',
  standalone: false, // eslint-disable-line
})
export class IsShopifyPipe implements PipeTransform {
  transform(store: DataObject<StoreBootstrap>): boolean;
  transform(stores: DataObject<StoreBootstrap>[], storeId: number | string): boolean;
  transform(
    storeOrStores: DataObject<StoreBootstrap> | DataObject<StoreBootstrap>[],
    storeId?: number | number,
  ): boolean {
    if (Array.isArray(storeOrStores)) {
      if (storeId === undefined) {
        return false;
      }
      return (
        storeOrStores.find((x) => +x.id === +storeId)?.attributes.subscriptions.attributes.billing_driver === 'shopify'
      );
    }

    return storeOrStores.attributes.subscriptions.attributes.billing_driver === 'shopify';
  }
}
